import React from 'react';

import cx from 'classnames';
import { SocialMediaLinks } from 'themes/common/components/NavItemSocial/SocialMediaLinks';

import type { TProfessional } from 'types/appointment';

import { Button } from '../Button/Button';

import s from './PlayfulTeamMember.module.css';

type TMemberProps = {
  professional: TProfessional;
  onClick: (professional: TProfessional) => void;
};

export const PlayfulTeamMember = ({ professional, onClick }: TMemberProps) => {
  const handleClick = () => onClick(professional);

  const isBookingEnabled =
    professional.available_for_booking &&
    professional.assigned_services.length > 0;

  const socialLinks = {
    facebook_url: professional.facebook_url,
    twitter_url: professional.twitter_url,
    instagram_url: professional.instagram_url,
    pinterest_url: professional.pinterest_url,
    yelp_url: professional.yelp_url,
    website_url: professional.website_url,
  };

  return (
    <article className={cx(s.root)}>
      <div className={s.imageWrapper}>
        <img
          className={s.image}
          src={professional.avatar_original}
          alt={professional.full_name}
          height="400"
          width="400"
        />
      </div>
      <div className={s.content}>
        <div className={s.description}>
          <h3 className={s.title}>{professional.full_name}</h3>
          <p className={cx(s.summary)}>{professional.about}</p>
          <SocialMediaLinks className={s.socials} urls={socialLinks} />
          {isBookingEnabled && (
            <Button className={s.button} onClick={handleClick}>
              Book
            </Button>
          )}
        </div>
      </div>
    </article>
  );
};
